import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import * as Sentry from '@sentry/react';
import Button from '@shape-construction/arch-ui/src/Button';
import { ErrorIcon } from '@shape-construction/arch-ui/src/Icons/custom';
import Link from '@shape-construction/arch-ui/src/Link';
import { breakpoints } from '@shape-construction/arch-ui/src/utils/breakpoints';
import { useMediaQuery } from '@shape-construction/hooks/src/useMediaQuery';
import { useModal } from '@shape-construction/hooks/src/useModal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { environment } from '../../config/environment';
import { AppVersion } from './AppVersion';
import CrashReport from './CrashReport';
export const CrashPage = t0 => {
  const $ = _c(64);
  const {
    resetError
  } = t0;
  const supportEmail = environment.SUPPORT_EMAIL;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("crashReport.subject");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subject = t1;
  const navigate = useNavigate();
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = breakpoints.up("md");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isLargeScreen = useMediaQuery(t2);
  const {
    open,
    openModal,
    closeModal
  } = useModal(false);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Sentry.getClient();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const client = t3;
  const isSentryAvailable = Boolean(client);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => client && Sentry.lastEventId() || null;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [eventId, setEventId] = useState(t4);
  const isFeedbackAvailable = isSentryAvailable && eventId;
  const url = window.location.href;
  let t5;
  if ($[5] !== openModal) {
    t5 = () => {
      if (isSentryAvailable) {
        openModal();
      }
    };
    $[5] = openModal;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const openCrashReportModal = t5;
  let t6;
  if ($[7] !== closeModal) {
    t6 = () => {
      if (isSentryAvailable) {
        closeModal();
      }
    };
    $[7] = closeModal;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const closeCrashReportModal = t6;
  let t7;
  if ($[9] !== navigate || $[10] !== resetError) {
    t7 = () => {
      if (resetError) {
        resetError();
      } else {
        navigate("/");
      }
    };
    $[9] = navigate;
    $[10] = resetError;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const goToProjects = t7;
  let t8;
  if ($[12] !== closeModal || $[13] !== eventId || $[14] !== goToProjects || $[15] !== subject) {
    t8 = t9 => {
      const {
        description
      } = t9;
      if (isSentryAvailable && eventId) {
        Sentry.captureFeedback({
          associatedEventId: eventId,
          email: supportEmail,
          message: description,
          name: subject,
          url,
          source: ""
        });
        setEventId(null);
        closeModal();
        goToProjects();
      }
    };
    $[12] = closeModal;
    $[13] = eventId;
    $[14] = goToProjects;
    $[15] = subject;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const submitCrashReport = t8;
  let t9;
  if ($[17] !== goToProjects || $[18] !== isFeedbackAvailable || $[19] !== isLargeScreen || $[20] !== openCrashReportModal || $[21] !== t) {
    t9 = () => {
      if (isFeedbackAvailable) {
        return <><Button color="primary" variant="contained" size="md" onClick={openCrashReportModal} fullWidth={!isLargeScreen}>{t("error.submitFeedbackCTA")}</Button><Link as="button" color="primary" onClick={goToProjects}>{t("error.goBackCTA")}</Link></>;
      }
      return <Button color="primary" variant="contained" size="md" onClick={goToProjects} fullWidth={!isLargeScreen}>{t("error.goBackCTA")}</Button>;
    };
    $[17] = goToProjects;
    $[18] = isFeedbackAvailable;
    $[19] = isLargeScreen;
    $[20] = openCrashReportModal;
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const renderButtonPanel = t9;
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ErrorIcon />;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("error.title");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = <div className="text-3xl font-bold">{t11}</div>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("error.content");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("error.contactCTA");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <a href={`mailto:${supportEmail}`} target="_blank" rel="noreferrer" className="font-medium text-indigo-500 hover:text-indigo-400">{t14}</a>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t15) {
    t16 = <p className="text-base leading-6">{t13}{" "}{t15}.</p>;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t16) {
    t17 = <div className="flex flex-col space-y-2 text-center">{t12}{t16}</div>;
    $[37] = t12;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== renderButtonPanel) {
    t18 = renderButtonPanel();
    $[40] = renderButtonPanel;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("error.sessionError");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t) {
    t20 = t("error.sessionErrorCTA");
    $[44] = t;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t20) {
    t21 = <a href="/logout" className="font-medium text-indigo-500 hover:text-indigo-400">{t20}</a>;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t19 || $[49] !== t21) {
    t22 = <p className="text-xs leading-6">{t19}{" "}{t21}.</p>;
    $[48] = t19;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <AppVersion />;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t17 || $[53] !== t18 || $[54] !== t22) {
    t24 = <div className="flex h-full flex-col items-center justify-center space-y-6 p-4">{t10}{t17}{t18}{t22}{t23}</div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t22;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== closeCrashReportModal || $[57] !== isFeedbackAvailable || $[58] !== open || $[59] !== submitCrashReport) {
    t25 = isFeedbackAvailable && open && <CrashReport onClose={closeCrashReportModal} onSubmit={submitCrashReport} />;
    $[56] = closeCrashReportModal;
    $[57] = isFeedbackAvailable;
    $[58] = open;
    $[59] = submitCrashReport;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t24 || $[62] !== t25) {
    t26 = <div className="h-screen">{t24}{t25}</div>;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  return t26;
};